// @ts-nocheck
import React, { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as FullscreenLoaderIcon } from '../../assets/loader.svg';

const FullscreenLoader = () => {
  const [showLoader, setShowLoader] = useState(false);
  const themes = useTheme();
  const showLoaderHandler = () => {
    setShowLoader(true);
  };

  const hideLoaderHandler = () => {
    setShowLoader(false);
  };

  useEffect(() => {
    document.addEventListener('showLoader', showLoaderHandler, false);
    document.addEventListener('hideLoader', hideLoaderHandler, false);

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('showLoader', showLoaderHandler);
      document.removeEventListener('hideLoader', hideLoaderHandler);
    };
  }, []);

  return (
    <>
      {showLoader && (
        <>
          <Backdrop
            sx={{
              color: themes.palette.other.white,
              zIndex: (theme) => theme.zIndex.modal + 1,
              transition: 'all .5s ease-in-out',
            }}
            open={showLoader}
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            <FullscreenLoaderIcon alt="Loading the page" color="primary" />
          </Backdrop>

          {/* Visually hidden text for screen readers */}
          <span
            role="alert"
            aria-live="polite"
            aria-atomic="true"
            style={{
              position: 'absolute',
              clip: 'rect(0 0 0 0)', // Clips the element completely so it’s not visible.
              overflow: 'hidden',
            }}
          >
            Loading
          </span>
        </>
      )}
    </>
  );
};

export default FullscreenLoader;
